import { useIsDarkMode } from '@flowus/common';
import { AiPage } from '@flowus/common/components/ai-page';
import { SearchParams } from '@flowus/login/const';
import { useMemo, type FC } from 'react';
import { getCurrentSpaceId } from 'src/hooks/space/get-space';
import { cache } from 'src/redux/store';
import { useObservableBlock } from 'src/services/rxjs-redux/use-obs-block';
import { judgeSharePage, judgeSubscribePage, useGetPageId } from 'src/utils/getPageId';

export const AiChatPage: FC = () => {
  const isDarkModel = useIsDarkMode();
  const pageId = useGetPageId();
  const isSubscribePage = judgeSubscribePage();
  const isSharePage = judgeSharePage();
  const spaceId = useObservableBlock(pageId, (s) => {
    return s?.spaceId;
  });

  // const helpCenterId = useMemo(() => {
  //   return tryGetHelperCenterId(pageId);
  // }, [pageId]);

  const params = useMemo(() => {
    const urlParams = new URLSearchParams(location.search);
    const params = new URLSearchParams();
    params.append(SearchParams.spaceId, getCurrentSpaceId());
    if (isSubscribePage) {
      params.append(SearchParams.aiType, 'subscribe');
    } else if (isSharePage && spaceId) {
      // 只有知识库页面才会显示
      params.append(SearchParams.aiType, 'knowledge');
      params.delete(SearchParams.spaceId);
      params.append(SearchParams.spaceId, spaceId);
      params.append(SearchParams.pageId, pageId);
      // params.append(SearchParams.searchAncestorId, helpCenterId);
    }
    const prompt = urlParams.get(SearchParams.defaultPrompt);
    if (prompt) {
      params.append(SearchParams.defaultPrompt, prompt);
    }
    return params;
  }, [isSharePage, isSubscribePage, pageId, spaceId]);

  return <AiPage isDarkModel={isDarkModel} pageId={pageId} addonUrlParams={params.toString()} />;
};

export const tryGetHelperCenterId = (pageId: string) => {
  let b = cache.blocks[pageId];
  let count = 0;
  while (b) {
    if (b.uuid === HELPER_CANTER_ID) return HELPER_CANTER_ID;
    b = cache.blocks[b.parentId];
    count++;
    if (count > 50) return;
  }
};
export const HELPER_CANTER_ID = 'e68380be-23cf-42c4-9b95-23a52713213d';
const OFFICIAL_SPACE_ID = 'e5418b54-223f-4f62-933f-cc5da586e910';
